<template>
  <ContentLoader :viewBox="viewBox" :height="height" :width="width">
    <rect x="30" y="40" rx="6" ry="6" width="100" height="20"></rect>
  </ContentLoader>
</template>

<script>
import { ContentLoader } from 'vue-content-loader';

export default {
  middleware: 'auth',
  components: {
    ContentLoader
  },
  props: {
    height: {
      required: false,
      default: '100'
    },
    width: {
      required: false,
      default: '500'
    },
    viewBox: {
      required: false,
      default: '0 0 500 300'
    }
  }
};
</script>
